import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Shield } from 'lucide-react';
import SEO, { SEO_CONFIG } from '@/components/SEO';

const PrivacyPage = () => {
  const { i18n } = useTranslation();
  const isEnglish = i18n.language === 'en';

  return (
    <div className="min-h-screen pt-20 bg-gradient-to-br from-purple-50 to-pink-50 py-12">
      <SEO {...SEO_CONFIG.privacy} />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Card>
          <CardHeader>
            <div className="flex items-center justify-center mb-4">
              <Shield className="h-12 w-12 text-purple-600" />
            </div>
            <h1 className="text-3xl font-bold text-center">
              {isEnglish ? 'Privacy Policy' : 'Gizlilik Politikası'}
            </h1>
          </CardHeader>
          <CardContent className="prose max-w-none">
            {isEnglish ? (
              <div className="space-y-6 text-gray-700">
                <p className="leading-relaxed">
                  At Pilatika, we value the privacy of our users' personal data.
                </p>
                <p className="leading-relaxed">
                  Personal information such as name, surname, email, and payment details shared during membership and payment processes are used solely for service delivery, payment processing, and fulfilling legal obligations.
                </p>
                <p className="leading-relaxed">
                  <strong>Credit card information is not stored in our systems.</strong> All payment transactions are securely processed through iyzico infrastructure.
                </p>
                <p className="leading-relaxed">
                  Personal data is protected under Law No. 6698 (KVKK - Personal Data Protection Law) and is not shared with third parties.
                </p>

                <h2 className="text-xl font-semibold text-gray-900 mt-8">Data We Collect</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Name and surname</li>
                  <li>Email address</li>
                  <li>Course enrollment and viewing history</li>
                  <li>Payment transaction records (not card details)</li>
                </ul>

                <h2 className="text-xl font-semibold text-gray-900 mt-8">How We Use Your Data</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>To provide access to purchased courses</li>
                  <li>To send course updates and notifications</li>
                  <li>To process payments securely</li>
                  <li>To improve our services</li>
                </ul>

                <h2 className="text-xl font-semibold text-gray-900 mt-8">Your Rights</h2>
                <p className="leading-relaxed">
                  You have the right to access, correct, or request deletion of your personal data. Contact us at info@pilatika.com for any requests.
                </p>
              </div>
            ) : (
              <div className="space-y-6 text-gray-700">
                <p className="leading-relaxed">
                  Pilatika olarak kullanıcılarımızın kişisel verilerinin gizliliğine önem veriyoruz.
                </p>
                <p className="leading-relaxed">
                  Üyelik ve ödeme süreçlerinde paylaşılan ad, soyad, e-posta ve ödeme bilgileri; yalnızca hizmetin sunulması, ödeme işlemlerinin gerçekleştirilmesi ve yasal yükümlülüklerin yerine getirilmesi amacıyla kullanılır.
                </p>
                <p className="leading-relaxed">
                  <strong>Kredi kartı bilgileri sistemlerimizde saklanmaz.</strong> Tüm ödeme işlemleri iyzico altyapısı üzerinden güvenli şekilde gerçekleştirilir.
                </p>
                <p className="leading-relaxed">
                  Kişisel veriler, 6698 sayılı KVKK kapsamında korunur ve üçüncü kişilerle paylaşılmaz.
                </p>

                <h2 className="text-xl font-semibold text-gray-900 mt-8">Topladığımız Veriler</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Ad ve soyad</li>
                  <li>E-posta adresi</li>
                  <li>Kurs kayıt ve izleme geçmişi</li>
                  <li>Ödeme işlem kayıtları (kart bilgileri hariç)</li>
                </ul>

                <h2 className="text-xl font-semibold text-gray-900 mt-8">Verilerinizi Nasıl Kullanıyoruz</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Satın alınan kurslara erişim sağlamak için</li>
                  <li>Kurs güncellemeleri ve bildirimler göndermek için</li>
                  <li>Ödemeleri güvenli şekilde işlemek için</li>
                  <li>Hizmetlerimizi geliştirmek için</li>
                </ul>

                <h2 className="text-xl font-semibold text-gray-900 mt-8">Haklarınız</h2>
                <p className="leading-relaxed">
                  Kişisel verilerinize erişme, düzeltme veya silme talebinde bulunma hakkınız vardır. Talepleriniz için info@pilatika.com adresinden bize ulaşabilirsiniz.
                </p>
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PrivacyPage;
